// FAR-83 §6: approving and removing an approval, each confirmed in a modal.
// Pure, so the wording and the stamp are tested without a browser.
import { formatDate } from '../../utils/format.js'

// "Approved Nov 3, 2026 by Mark Van Driel". The name is the one stamped at
// approval (FAR-83 §6); older approvals only have the user ID.
export function approvalStamp(plan) {
  if (!plan?.approvedAt) return null
  const who = plan.approvedByName || plan.approvedBy
  return `Approved ${formatDate(plan.approvedAt)}${who ? ` by ${who}` : ''}`
}

// The two modals: "approve the plan as of that moment or cancel", and "remove
// the approval or cancel".
export function confirmText(action, plan) {
  const name = plan?.name ? `"${plan.name}"` : 'this plan'
  if (action === 'approve') {
    return {
      title: 'Approve this plan?',
      body: `Approve ${name} as it is now? The approval records your name, user ID and the date and time.`,
      confirm: 'Approve',
    }
  }
  const stamp = approvalStamp(plan)
  return {
    title: 'Remove approval?',
    body: `Remove the approval from ${name}?${stamp ? ` (${stamp}.)` : ''} Its approval entry is deleted.`,
    confirm: 'Remove Approval',
  }
}
